import { render, staticRenderFns } from "./Tenants.vue?vue&type=template&id=05ccef38&"
import script from "./Tenants.vue?vue&type=script&lang=js&"
export * from "./Tenants.vue?vue&type=script&lang=js&"
import style0 from "./Tenants.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports